export const onDisabledScrollHandler = () => {
  return (document.body.style.overflow = "hidden");
};

export const onEnableScrollHandler = () => {
  return (document.body.style.overflow = "inherit");
};

export const windowScreenWidth = (): boolean => {
  let width = window.innerWidth || document.body.clientWidth;
  if (width <= 768) return true;
  else {
    return false;
  }
};
